import { FC, ReactNode } from "react";
import { format, isValid, parse, parseISO } from "date-fns";
import { PrescriberInformationProps } from "../prescriberInformation/types";

const PriorDiureticsTreatment: FC<PrescriberInformationProps> = ({
  caseObject,
}): JSX.Element => {
  const { prior_treatment_attributes,prior_treatment_applied_attributes,prior_treatment_reason_attributes } = caseObject;

  const appliedPriorTreatment =
    prior_treatment_applied_attributes || [];

  const reasonPriorTreatment =
    prior_treatment_reason_attributes || [];

  const drugsPriorTreatment =
   prior_treatment_attributes || [];

  // const lastFev1Date =
  //   prescription_information?.last_fev1_date ||
  //   prescription_information?.date_of_last_fev1;

  const formatDate = (date: string | number | Date | null | undefined) => {
    if (!date) return "-";

    const parsedDate = parseISO(date as string);
    if (!isValid(parsedDate)) return String(date);

    return format(parsedDate, "MM/dd/yyyy");
  };

  const normalizeArray = (value: any): string[] => {
    if (!value) return [];

    if (Array.isArray(value)) {
      return value.filter(Boolean).map((item) => String(item));
    }

    return [String(value)];
  };

  const Section = ({
    title,
    children,
  }: {
    title: string;
    children: ReactNode;
  }) => (
    <div style={{ marginBottom: "20px" }}>
      <h5 className="text-primary">
        {title}
      </h5>

      {children}
    </div>
  );

  return (
    <div className="card">
      <div className="card-header">
        <h1 className="m-0">Current and Prior Treatment</h1>
      </div>

      <div className="card-body">
        <div className="row">
          <div style={{ padding: "20px", width: "100%" }}>
            {/* Prior Treatment */}
            <Section title="Prior Treatment">
              <div className="table-responsive-sm table-responsive-md table-responsive-lg">
                <table className="table table-striped table-sm">
                  <thead>
                  <tr className="text-center">
                    <th>Drug</th>
                    <th>Failure Reason</th>
                    <th>Date Tried</th>
                  </tr>
                  </thead>

                  <tbody>
                  {drugsPriorTreatment.length > 0 ? (
                      drugsPriorTreatment.map((item: any, i: number) => (
                          <tr key={i} className="text-center">
                            <td>{item.drug_name || "-"}</td>
                            <td>{item.failure_reason || "-"}</td>
                            <td>{formatDate(item.date_tried)}</td>
                          </tr>
                      ))
                  ) : (
                      <tr>
                        <td colSpan={3} style={{ textAlign: "center" }}>
                          No Prior Treatment Found
                        </td>
                      </tr>
                  )}
                  </tbody>
                </table>

              </div>
            </Section>

            {/* Reasons */}
            <Section title="Reasons Alternative Insulins Not Effective">
              {reasonPriorTreatment.length > 0 ? (
                reasonPriorTreatment.map((item: any, i: number) => {
                  const reasons = normalizeArray(item.reason);
                  const subReasons = normalizeArray(item.sub_reasons);

                  return (
                    <div key={i} style={{ marginBottom: "10px" }}>
                      {reasons.map((reason, index) => (
                        <p key={index} className="mb-1">
                          <i className="bi bi-check-all me-1 text-primary"></i>
                          {reason}
                        </p>
                      ))}

                      {subReasons.length > 0 && (
                        <div style={{ marginLeft: "24px" }}>
                          {subReasons.map((subReason, idx) => (
                            <p key={idx} className="mb-1">
                              <i className="bi bi-check-all me-1 text-primary"></i>
                              {subReason}
                            </p>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                <p>-</p>
              )}
            </Section>

            {/* Applicable to Patient */}
            <Section title="Applicable to Patient">
              {appliedPriorTreatment.length > 0 ? (
                appliedPriorTreatment.map((item: any, i: number) => {
                  const reasons = normalizeArray(item.reason);
                  const subReasons = normalizeArray(item.sub_reasons);

                  return (
                    <div key={i} style={{ marginBottom: "10px" }}>
                      {reasons.map((reason, index) => (
                        <p key={index} className="mb-1">
                          <i className="bi bi-check-all me-1 text-primary"></i>
                          {reason}
                        </p>
                      ))}

                      {subReasons.length > 0 && (
                        <div style={{ marginLeft: "24px" }}>
                          {subReasons.map((subReason, idx) => (
                            <p key={idx} className="mb-1">
                              <i className="bi bi-check-all me-1 text-primary"></i>
                              {subReason}
                            </p>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                <p>-</p>
              )}
            </Section>
            {/* <Section title="Applicable to Patient">
              {appliedPriorTreatment.length > 0 ? (
                appliedPriorTreatment.map((item: any, i: number) => (
                  <p key={i} className="mb-1">
                    <i className="bi bi-check-all me-1"></i>
                    {String(item)}
                  </p>
                ))
              ) : (
                <p>-</p>
              )}
            </Section> */}

            {/* Additional Info */}
            {/* <Section title="Additional Info">
              <p>
                <strong>Date of Last FEV1:</strong> {formatDate(lastFev1Date)}
              </p>
            </Section> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PriorDiureticsTreatment;